<template>
    <div v-if="shop" class="single-shop" id="edit-shop-container">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="single-shop__">
                        <div class="single-shop__content">
                            <EditShopProfile 
                                :data="shop" 
                                @setData = "setData" 
                                edit-view 
                                ref="editProfileRef"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 mt-lg-0 mt-3">
                    <div class="single-shop__">
                        <div class="single-shop__content">
                            <CrosspromOptions 
                                :data="shop" 
                                @setData = "setData"
                                edit-view
                                ref = "crosspromOptionsRef"
                            >
                                <div class="mt-5 text-right">
                                    <Button class="btn-outline mr-3" @click.native="cancel">Cancel</Button>
                                    <Button class="btn-purple" @click.native="saveData">Save Changes</Button>
                                </div>
                            </CrosspromOptions>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <UnsavedChanges
            v-if="hasChanges"
            title="You have unsaved changes"
            text="Do you want to keep them?"
            save-text="Save"
            no-text="No"
            @submit="onModalSave"
            @no="leavePage"
            @close="onModalHide"/>
    </div>
</template>

<script>
import CrosspromOptions from '../../components/Ecommerce/CrosspromOptions'
import EditShopProfile from '../../components/Ecommerce/EditShopProfile'
import Step3 from '../Ecommerce/Steps/Step3'
import useGetShop from '../../components/Ecommerce/useGetShop'
import {useRouter, useErrors} from '../../core/hooks'
import {provideErrors} from '../../core/providers'
import Button from './../../components/Theme/Button'
import { ref, onMounted, watch, computed } from '@vue/composition-api'
import {ShopsService} from '../../core/services'
import {message} from 'ant-design-vue'
import UnsavedChanges from '../../popups/UnsavedChangesEcommerce'
import useUnsavedOnClose from '../../components/Ecommerce/useUnsavedOnClose'

export default {
    name: 'EditShop',
    components: {
        CrosspromOptions,
        EditShopProfile,
        Button,
        UnsavedChanges
    },
    beforeRouteLeave (to, from , next) {
        console.log('leave a anum')
        this.checkPage(to, next)
    },
    setup(props, {root}){
        provideErrors([
            'empty-description',
            'empty-title',
            'missing-logo',
            'missing-cover',
            'no-crossprom-option-selected',
            'missing-subscribers-number',
            'missing-banner-link',
            'missing-blog-page-link',
            'missing-other-description'
        ]);

        const errorHandler = useErrors();

        const editProfileRef = ref()
        const crosspromOptionsRef = ref()

        const {route, router} = useRouter()

        // if(this.$route.query.id){
        //     this.getData();
        //     this.showColumns = true;
        // } else {
        //     this.$router.push('/404').catch(() => {});
        // }

        const {shop} = useGetShop(route.value.params.shopId)
        const {setShopChanges, setCachedData} = useUnsavedOnClose(shop.value)

        const initialShop = ref(null)
        const hasChanges = ref(false)


        onMounted(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        })

        watch(shop, (newVal, oldVal) => {
            if(newVal && !newVal.id) {
                router.push('/').catch(() => {})
            }

            if(!oldVal && newVal && newVal.id) {
                initialShop.value = JSON.stringify(newVal)
            }

            if(newVal) {
                setShopChanges(newVal)
            }

            if(newVal && !oldVal) {
                setCachedData(newVal)
            }

        }, {immediate: true})


        const setData = (data) => {
            shop.value = data
        }

        const saveData = async () => {
            errorHandler.resetErrors()
            await editProfileRef.value.validateFields()
            await crosspromOptionsRef.value.validateFields()

            if(errorHandler.hasError()){
                return
            }

            try {
                await ShopsService.update(shop.value)
                initialShop.value = JSON.stringify(shop.value)
                setShopChanges(shop.value)
                setCachedData(shop.value)
                message.success('Changes are successfully saved')

                root.$sendMixpanelEvent('Shop Edited', {
                    'Shop': shop.value.title
                })

                root.$ga.event('Shop', 'Shop Edited', `
                    Shop: ${shop.value.title}
                `)

            } catch(e) {
                message.error('Something went wrong')
            } finally {
                return 'saved'
            }
        }

        const routeTo = ref(null)

        const checkPage = async (to, next) => {

            hasChanges.value = initialShop.value !== JSON.stringify(shop.value)

            if(!hasChanges.value) {
                routeTo.value = null
                return next()
            }
            routeTo.value = to
        }

        const leavePage = () => {
            setShopChanges(shop.value)
            setCachedData(shop.value)
            initialShop.value = JSON.stringify(shop.value)
            router.push({ path: routeTo.value.path })
            console.log('leavepagen a ashxatum')
        }

        const onModalHide = () => {
            hasChanges.value = false
        }

        const cancel = () => {
            return router.push('/').catch(() => {})
        }

        const onModalSave = async () => {
            const resp = await saveData()
            hasChanges.value = false
            if(resp) {
                leavePage()
            }
        }


        return {
            shop,
            setData,
            saveData,
            editProfileRef,
            crosspromOptionsRef,
            hasChanges,
            onModalHide,
            cancel,
            onModalSave,
            leavePage,
            checkPage,
            initialShop,
            routeTo
        }
    }
}
</script>
<style lang="scss" scoped>
$space32: 32px;
$space24: 24px;
$space20: 20px;
$space16: 16px;
$padding: 0 40px;
$white: #ffffff;
$border_radius: 12px;
$shadow: 0px 12px 12px -6px rgba(113, 128, 150, 0.16), 0px 0px 1px rgba(113, 128, 150, 0.2);
$top_shadow: 0px -6px 12px -6px rgba(113, 128, 150, 0.12), 0px 0px 1px rgba(113, 128, 150, 0.16);

.single-shop{
    &__ {
        height: 100%;
        background: white;
        border-radius: $border_radius;
        box-shadow: $shadow;
        display: flex;
        flex-direction: column;
        padding: 40px 0;
    }
    &__image {
        height: 240px;
    }
    &__content {
        padding: $padding;
        &__width-footer {
            flex: 1 1 auto;
            overflow-y: auto;
        }
    }
    &__footer {
        display: flex;
        justify-content: center;
        align-items: center;
        box-shadow: $top_shadow;
        height: 88px;
    }
    .space24 {
        margin-bottom: $space24;
    }
    .space20 {
        margin-bottom: $space20;
    }
    .space16 {
        margin-bottom: $space16;
    }
    .space32 {
        margin-bottom: $space32;
    }
}
</style>>
